import React from 'react';
import { BACKERS } from './assets';

export { AppleIcon, GooglePlayIcon, PlayStoreIcon } from './StoreIcons';

export const ArrowIcon = () => (
  <svg width="12" height="12" viewBox="0 0 12 12" fill="none" stroke="currentColor" strokeWidth={2}>
    <path d="M2 6h8M7 3l3 3-3 3" />
  </svg>
);

// Backer tiles shared between Home and About.
export function BackerTiles() {
  return (
    <>
      {BACKERS.map((backer) => (
        <div className="backer-tile" key={backer.name}>
          <img className="backer-tile-logo" src={backer.logo} alt="" aria-hidden="true" />
          <div className="backer-tile-name">{backer.name}</div>
        </div>
      ))}
    </>
  );
}
